<template>
  <section class="section-wrapper white">
    <v-container>
      <h2>M&A Consulting</h2>

      <div>
        <div class="description-section">
          <p>
            Succession Resource Group is a boutique succession planning consulting firm dedicated to helping financial advisors and other small business owners value, grow, protect and plan for the transition of their business. Serving clients across the country, Succession Resource Group provides the most accurate and comprehensive valuations services, turnkey acquisition support, assistance creating contingency plans, and personalized succession/exit strategies.
          </p>
          <a
            class="default-btn blue"
            href="https://www.successionresource.com/"
            target="_blank"
          >Visit Succession Resource Group</a>
        </div>

        <div
          v-if="$vuetify.breakpoint.mdAndUp"
          class="services-container"
        >
          <a
            v-for="(item, index) in assistanceItems"
            :href="item.link" target="_blank"
            :key="index"
          >{{ item.name }}</a>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'HomeFacilitatingAssistance',
  data: () => ({
    assistanceItems: [
      {
        name: 'Acquire Edge',
        link: 'https://successionresource-6155808.hs-sites.com/acquire-edge',
      },
      {
        name: 'Turnkey Deal Support',
        link: 'https://successionresource-6155808.hs-sites.com/service-turnkey-deal-support',
      },
      {
        name: 'FA CMA Valuation',
        link: 'https://successionresource-6155808.hs-sites.com/fa-cma-valuation',
      },
      {
        name: 'Succession Blueprint',
        link: 'https://successionresource-6155808.hs-sites.com/succession-blueprint',
      },
      {
        name: 'Seller Advocacy',
        link: 'https://successionresource-6155808.hs-sites.com/seller-advocacy',
      },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.section-wrapper .container {
  display: flex;
  flex-direction: column;
  min-height: unset;

  @include md {
    background: {
      color: transparent;
      image: url("~@/modules/home/assets/compass-background.png");
      position: center center;
      size: contain;
    }
  }

  align-items: center;
  @include md { align-items: flex-start; }

  & > div {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  h2 {
    color: $textGrey;
    margin-bottom: 35px;
  }

  .description-section {
    flex-grow: 1;
    flex-shrink: 0;
    align-items: center;

    width: 100%;

    text-align: center;

    @include md {
      align-items: flex-start;
      width: 70%;
      padding-right: 5%;

      text-align: left;
    }
    @include xl { width: 50%; }

    p {
      color: #0A0A0A;
      font-family: "Avenir Book", sans-serif;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0;

      margin-bottom: 30px;
    }

    a {
      margin: 0;
      white-space: nowrap;
    }
  }

  .services-container {
    margin-top: -5px;

    display: grid;
    grid-template-columns: 1fr;
    @include xl { grid-template-columns: 1fr 1fr; }

    grid-column-gap: 20px;
    grid-row-gap: 25px;

    a {
      display: flex;
      align-items: center;

      color: $textGrey;
      font-family: "Sansation Bold", Serif;
      font-size: 16px;
      line-height: 18px;
      letter-spacing: 0;
      text-decoration: none;
      white-space: nowrap;

      &:hover {
        color: rgba($textGrey, 0.8);
      }

      @include lg {
        font-size: 22px;
        line-height: 26px;
      }
    }
  }
}
</style>
